'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@lib/utils';

const toolTipContentColor = {
  primary: 'pui-bg-primary pui-text-text-white',
  info: 'pui-bg-state-info pui-text-text-white',
  success: 'pui-bg-state-success pui-text-text-white',
  error: 'pui-bg-state-error pui-text-text-white',
  warning: 'pui-bg-state-warning pui-text-text-white',
  default: 'pui-bg-background pui-text-text-primary',
};

const toolTipArrowColor = {
  primary: 'pui-fill-primary',
  info: 'pui-fill-state-info',
  success: 'pui-fill-state-success',
  error: 'pui-fill-state-error',
  warning: 'pui-fill-state-warning',
  default: 'pui-fill-background',
};

function TooltipProvider({ delayDuration = 0, ...props }) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip({ delayDuration, ...props }) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  );
}

function TooltipTrigger({ ...props }) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

function TooltipContent({
  className,
  sideOffset = 0,
  color,
  children,
  ...props
}) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'pui-px-3 pui-py-2 pui-border pui-border-stroke-primary pui-shadow-tooltip pui-animate-in pui-fade-in-0 pui-zoom-in-95 data-[state=closed]:pui-animate-out data-[state=closed]:pui-fade-out-0 data-[state=closed]:pui-zoom-out-95 data-[side=bottom]:pui-slide-in-from-top-2 data-[side=left]:pui-slide-in-from-right-2 data-[side=right]:pui-slide-in-from-left-2 data-[side=top]:pui-slide-in-from-bottom-2 pui-z-50 pui-w-fit pui-origin-(--radix-tooltip-content-transform-origin) pui-rounded-lg pui-text-p-sm pui-text-balance',
          className,
          toolTipContentColor[color] || 'pui-bg-background-strong'
        )}
        data-testid="tooltip-content"
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow
          className={cn(
            'pui-z-50 pui-size-2.5 pui-border-b pui-border-r pui-border-stroke-primary pui-translate-y-[calc(-50%_-_2px)] pui-rotate-45 pui-rounded-[2px]',
            toolTipContentColor[color] || 'pui-bg-background',
            toolTipArrowColor[color] || 'pui-fill-background'
          )}
        />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
